import {BaseModel} from '../base-model';
import {IGenerateConfig} from './generate-config.model';
import {IColumnOptions} from "../../components/grid/grid-options";

export interface IGridConfigColumn {
	Fields?: IGenerateConfig[];
	ViewMode?: string | number;
}

export class GridConfigColumn {
	Fields?: IGenerateConfig[];
	ViewMode?: string | number;
	
	constructor(props?: IGridConfigColumn) {
		this.Fields = props.Fields || [];
		this.ViewMode = props.ViewMode || 0;
	}
}

export interface IGridConfiguration {
	Config?: IGridConfigColumn;
	OwnerType?: GridOwnerType;
	FilterId?: number;
	FilterIds?: any[];
	UserIds?: number[];
}

export class GridConfiguration extends BaseModel<IGridConfiguration> {
	Config?: IGridConfigColumn;
	OwnerType?: GridOwnerType;
	FilterId?: number;
	FilterIds?: any[];
	UserIds?: number[];
	
	constructor(props?: IGridConfiguration) {
		super(props);
		this.Config.Fields = props.Config.Fields || [];
		this.Config.ViewMode = props.Config.ViewMode || 0;
		this.OwnerType = props.OwnerType || GridOwnerType.GlobalUser;
		this.FilterId = props.FilterId || -1;
		this.FilterIds = props.FilterIds || [];
		this.UserIds = props.UserIds || [];
	}
}

// export interface ISearchProperty extends IGridConfiguration{}
//
// export class SearchProperty extends BaseModel<ISearchProperty>{
//     Fields: IGenerateConfig[];
//     constructor() {
//         super();
//         this.Fields = []
//     }
// }
//
// export interface ISearchPerson extends IGridConfiguration {}
//
// export class SearchPerson extends BaseModel<ISearchPerson>{
//     Fields: IGenerateConfig[];
//     constructor() {
//         super();
//         this.Fields = []
//     }
// }
//
// export interface ISearchDemand extends IGridConfiguration {}
//
// export class SearchDemand extends BaseModel<ISearchDemand>{
//     Fields: IGenerateConfig[];
//     constructor() {
//         super();
//         this.Fields = []
//     }
// }
//
// export interface ISearchTask extends IGridConfiguration {}
//
// export class SearchTask extends BaseModel<ISearchTask>{
//     Fields: IGenerateConfig[];
//     constructor() {
//         super();
//         this.Fields = []
//     }
// }

// export interface IDemandProposals extends IGridConfiguration {}
//
// export class DemandProposals extends BaseModel<IDemandProposals>{
//     Fields: IGenerateConfig[];
//     constructor() {
//         super();
//         this.Fields = []
//     }
// }

export enum GridOwnerType {
	User = 1 ,
	Filter = 2 ,
	GlobalUser = 3 ,
	GlobalFilter = 4 ,
}

export interface IPayloadGridConfiguration {
	moduleType: number;
	columns: IColumnOptions[];
	ownerType?: GridOwnerType;
	filterId?: number;
	filterIds?: any[];
	userIds?: number[];
}

export class PayloadGridConfiguration implements IPayloadGridConfiguration {
	moduleType: number;
	columns: IColumnOptions[];
	ownerType ?: GridOwnerType;
	filterId?: number;
	filterIds?: any[];
	userIds ?: number[];
	
	constructor(props: IPayloadGridConfiguration) {
		this.moduleType = props.moduleType;
		this.columns = props.columns;
		this.ownerType = props.ownerType || GridOwnerType.GlobalUser;
		this.filterId = props.filterId || 0;
		this.filterIds = props.filterIds || [];
		this.userIds = props.userIds || [];
	}
}